import { render, staticRenderFns } from "./VaSelect.demo.vue?vue&type=template&id=9d11f964&"
import script from "./VaSelect.demo.vue?vue&type=script&lang=js&"
export * from "./VaSelect.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports